import { z } from 'zod';

import { JOURNAL_ENTRY_TYPES, RULE_KEYS } from '../enums';

const optionalTrimmed = z.string().trim().min(1).optional();
const nullableNumber = z.number().nullable();

export const PostTradeReviewSchema = z.object({
  rulesFollowed: z.array(z.enum(RULE_KEYS)),
  rulesBroken: z.array(z.enum(RULE_KEYS)),
  outcomeR: nullableNumber,
  whatWorkedWell: z.string().trim().min(10),
  whatWentWrong: z.string().trim().min(10),
  lessons: z
    .string()
    .trim()
    .min(20)
    .refine((value) => !/[?!]\s+|\.\s+\S/.test(value), {
      message: 'Write one concise instruction sentence.',
    }),
  emotionalRegret: z.number().int().min(1).max(5),
});

const BaseJournalEntrySchema = z.object({
  accountId: optionalTrimmed,
  symbol: optionalTrimmed,
  tradePlanId: optionalTrimmed,
  tradeId: optionalTrimmed,
  entryType: z.enum(JOURNAL_ENTRY_TYPES),
  thesis: optionalTrimmed,
  whyNow: optionalTrimmed,
  invalidation: optionalTrimmed,
  emotionalState: optionalTrimmed,
  tags: z.array(z.string().trim().min(1)).optional(),
  body: z.string(),
  planAdherence: optionalTrimmed,
  dominantEmotion: optionalTrimmed,
  oneLineLesson: z.string().trim().max(140).optional(),
  whatHappened: z.string().trim().max(500).optional(),
  whatToChange: z.string().trim().max(500).optional(),
});

export const CreateJournalEntrySchema = BaseJournalEntrySchema.merge(
  PostTradeReviewSchema.partial(),
);

export const UpdateJournalEntrySchema = CreateJournalEntrySchema.partial();

export type CreateJournalEntryInput = z.infer<typeof CreateJournalEntrySchema>;
export type UpdateJournalEntryInput = z.infer<typeof UpdateJournalEntrySchema>;
export type PostTradeReviewInput = z.infer<typeof PostTradeReviewSchema>;
